import { initialPath } from "~misc/paths";
import {
  CepIconHome,
  CNPJIconHome,
  CPPIcon,
  FunnelIcon,
  GranelIcon,
  IconPrancheta,
  IMOIcon,
  LoadPositionIcon,
  Maintenance,
  PortfolioIcon,
  QlikIcon,
  ReflexIcon,
  RegisterIcon,
  ResearchManagementIcon,
  RouteIcon,
  SimulatorsHeaderIcon,
  SimulatorsIcon,
  StoreVCIcon,
  TACDashboardIcon,
  VespaTACIcon,
  VirtualstoreIcon,
  VLOZIcon,
  IconSalesManagement
} from "../misc/icons";
import { PagueFlex, TaticaCliente, CapIcon, LemontechIcon, FioriIcon, ConcurIcon, MapaObra, Matrix, TreinamentoDtm, LaboratorioMovel, ReflexIconSemTagline } from "~misc/png_logos";
import { AcessosSlug } from "./GlobalServices";
const menuMap = {
    "acesso-ao-menu-de-rota-do-dia": {
      name: "Rota do dia",
      route: `${initialPath}/roteirizacao/mapa`,
      icon: <RouteIcon />
    },
    "acesso-ao-menu-de-carteira": {
      name: "Carteira",
      route: `${initialPath}/carteira`,
      icon: <PortfolioIcon />
    },
    "acesso-ao-menu-de-cadastro-de-clientes": {
      name: "Cadastro e Crédito",
      route: `${initialPath}/cadastro-e-credito`,
      icon: <RegisterIcon />,
      identity: 'cadastro'
    },
    "acesso-ao-menu-de-gestao-de-vendas": {
      name: "Gestão de Vendas",
      route: `${initialPath}/gestao-de-vendas`,
      icon: <IconSalesManagement />
    },
    "acesso-ao-menu-de-simuladores": {
      name: "Simuladores",
      route: `${initialPath}/simuladores`,
      icon: <SimulatorsHeaderIcon />
    },
    "acesso-ao-menu-de-tabela-de-precos": {
      name: "Tabela de Preços",
      route: `${initialPath}/tabela-preco`,
      icon: <SimulatorsIcon />
    },
    "acesso-ao-menu-de-funil-de-obras": {
      name: "Funil de Obras",
      route: `${initialPath}/funil-de-obras/proximas-negociacoes`,
      icon: <FunnelIcon />
    },
    "acesso-ao-menu-de-reflex": {
      name: "Reflex",
      route: `${initialPath}/reflex/mes-atual`,
      icon: <ReflexIconSemTagline />,
      isReflex: true
    },
    "acesso-ao-atalho-da-loja-virtual": {
      name: "Loja Virtual",
      route: `https://admin-loja.juntossomosmais.com.br/login`,
      target: "_blank",
      icon: <VirtualstoreIcon />
    },

    "acesso-ao-atalho-de-simulador-imo": {
      name: "SIMULADOR IMO/INFRA",
      tag: "simulador-imo",
      route: `https://comercial.vcimentos.com/#/imo`,
      target: "_blank",
      icon: <IMOIcon />,
      type: "atalho"
    },
    "acesso-ao-atalho-de-simulador-cpp": {
      name: "Simulador CPP",
      tag: "simulador-cpp",
      route: `https://comercial.vcimentos.com/#/cpp`,
      target: "_blank",
      icon: <CPPIcon />,
      type: "atalho"
    },
    "acesso-ao-atalho-de-simulador-granel": {
      name: "Simulador Granel",
      tag: "simulador-granel",
      route: `https://comercial.vcimentos.com/#/granel`,
      target: "_blank",
      icon: <GranelIcon />,
      type: "atalho"
    },

    "acesso-ao-atalho-de-dashboard-tac": {
      name: "Dashboard TAC",
      tag: "dashboard-tac",
      route: `https://vcimentos.us.qlikcloud.com/sense/app/32e2e990-9728-4bb1-847f-cffb773dabcf/hubUrl/%2Fanalytics%2Fhome`,
      target: "_blank",
      icon: <TACDashboardIcon />,
      type: "atalho"
    },
    "acesso-ao-atalho-de-tatica-cliente": {
      name: "Tática do Cliente",
      tag: "tatica-cliente",
      route: `https://vcimentos.us.qlikcloud.com/sense/app/a35464f2-19dd-4fdd-9138-6d1649bf2d62`,
      target: "_blank",
      icon: <TaticaCliente />,
      type: "atalho"
    },
    "acesso-ao-atalho-de-reflex": {
      name: "Reflex",
      tag: "reflex",
      route: `https://www.reflexvc.com.br/`,
      target: "_blank",
      icon: <ReflexIcon />,
      type: "atalho"
    },
    "acesso-ao-atalho-calculadora-pague-flex": {
      name: "Calculadora Pague Flex",
      tag: "calculadora-pague-flex",
      route: `https://pagueflex.z21.web.core.windows.net/`,
      target: "_blank",
      icon: <PagueFlex />,
      type: "atalho"
    },
    "acesso-ao-atalho-app-vloz": {
      name: "App VLOZ",
      tag: "app-vloz",
      route: `https://www.vloz.app/home`,
      target: "_blank",
      icon: <VLOZIcon />,
      type: "atalho"
    },
    "acesso-ao-atalho-cnpj": {
      name: "Consulta CNPJ",
      tag: "consulta-cnpj",
      route: `https://solucoes.receita.fazenda.gov.br/servicos/cnpjreva/cnpjreva_solicitacao.asp`,
      target: "_blank",
      icon: <CNPJIconHome />,
      type: "atalho"
    },
    "acesso-ao-atalho-cep": {
      name: "Consulta CEP",
      tag: "consulta-cep",
      route: `https://buscacepinter.correios.com.br/app/endereco/index.php`,
      target: "_blank",
      icon: <CepIconHome />,
      type: "atalho"
    },
    "acesso-ao-atalho-mapa-obra": {
      name: "Mapa da obra",
      tag: "mapa-obra",
      route: `https://www.mapadaobra.com.br/produtos/`,
      target: "_blank",
      icon: <MapaObra />,
      type: "atalho"
    },
    "acesso-ao-atalho-matrix": {
      name: "Vc Matrix",
      tag: "vc-matrix",
      route: `https://matrix.iesrv.com.br/`,
      target: "_blank",
      icon: <Matrix />,
      type: "atalho"
    },
    "acesso-ao-atalho-simuladore-vespa-tac": {
      name: "Simulador VESPA TAC",
      tag: "simulador-vespa-tac",
      route: `https://icy-rock-06992710f.3.azurestaticapps.net/home`,
      target: "_blank",
      icon: <VespaTACIcon />,
      type: "atalho"
    },
    "acesso-ao-atalho-vc-store": {
      name: "VC STORE",
      tag: "vc-store",
      route: `https://vcstore.com.br/login`,
      target: "_blank",
      icon: <StoreVCIcon />,
      type: "atalho"
    },
    "acesso-ao-atalho-relatorios-qlik-sense": {
      name: "Relatórios Qlik Sense",
      tag: "relatorios-qlik-sense",
      route: `https://vcimentos.us.qlikcloud.com/analytics/home`,
      target: "_blank",
      icon: <QlikIcon />,
      type: "atalho"
    },
    "acesso-ao-menu-de-gestao-de-pesquisas": {
      name: "Formulários",
      route: `${initialPath}/gestao-de-pesquisa`,
      icon: <IconPrancheta />
    },
    "acesso-ao-atalho-de-cap": {
      name: "CAP",
      tag: "cap",
      route: `https://vcimentos.capworkflow.com/`,
      target: "_blank",
      icon: <CapIcon />,
      type: "atalho"
    },
    "acesso-ao-atalho-de-problemas-tecnicos": {
      name: "Problemas Técnicos",
      route: `/problemas-tecnicos`,
      target: "_self",
      icon: <Maintenance />
    },
    "acesso-ao-atalho-fiori": {
      name: "Portal de aprovações",
      tag: "portal-de-aprovacoes",
      route: `https://fiori.votorantim.com.br/`,
      target: "_blank",
      icon: <FioriIcon />,
      type: "atalho"
    },
    "acesso-ao-atalho-concur": {
      name: "Concur",
      tag: "concur",
      route: `https://us2.concursolutions.com/home`,
      target: "_blank",
      icon: <ConcurIcon />,
      type: "atalho"
    },
    "acesso-ao-atalho-lemontech": {
      name: "Lemontech",
      tag: "lemontech",
      route: `https://selfbooking.lemontech.com.br/`,
      target: "_blank",
      icon: <LemontechIcon />,
      type: "atalho"
    },
    "acesso-ao-atalho-treinamento-dtm": {
      name: "Treinamento DTM",
      tag: "treinamento-dtm",
      route: `https://forms.office.com/Pages/ResponsePage.aspx?id=-I0VSd8Esk2hru45Sco5hJPNt8zEcVZDlzW-WZxlGtNUNk1UNUk0OUVTTjdTUjg5NlVBMjFLN1gxMS4u`,
      target: "_blank",
      icon: <TreinamentoDtm />,
      type: "atalho"
    },
    "acesso-ao-atalho-lab-movel": {
      name: "LAB.MÓVEL",
      tag: "lab-movel",
      route: `https://dtm-tec.iesrv.com.br/`,
      target: "_blank",
      icon: <LaboratorioMovel />,
      type: "atalho"
    },
};

export const getMenu = (usuario, params = {}) => {
  if (!usuario?.ativo) return [];

  const temAcessoSomenteReflex =
    usuario?.slugAcessos?.includes("acesso-somente-ao-menu-de-reflex");

  if (temAcessoSomenteReflex) {
    return [menuMap["acesso-ao-menu-de-reflex"]];
  }

  const map = { ...menuMap };

  if (params.lojaVirtualUrl) {
    map["acesso-ao-atalho-da-loja-virtual"] = {
      ...map["acesso-ao-atalho-da-loja-virtual"],
      route: params.lojaVirtualUrl,
    };
  }

  return Object.keys(map)
    .filter(key => AcessosSlug(usuario?.slugAcessos, key))
    .map(key => map[key]);
};

